import { createFileRoute } from '@tanstack/react-router';

import { Home } from '@/components/home/Home';

export const ROUTE_CONSTANTS = {
  HOME_PATH: '/',
  APPS_PATH: '/apps',
  LOGIN_PATH: '/login',
  DOCUMENT_PATH: '/documents',
  CONTACTS_PATH: '/contacts',
};

export const Route = createFileRoute('/')({
  component: Home,
});
